import React, { useEffect, useState } from "react"
import { Col, Card, CardBody, Row } from "reactstrap"
import { get } from 'helpers/api_helper'

const FMYTDWidget = () => {
  const [reportType, setReportType] = useState("ftd")
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(async () => {
    setLoading(true)
    setData(null)
    try {
      const res = await get(`api/org/termdeposits/${reportType}`)
      if (res && res.status == 200) {
        setData(res.response)
      }
    } catch (err) {
      console.error("FMYTD error:", err)
    } finally {
      setLoading(false)
    }
  }, [reportType])

  const reports = [
    {
      icon: "bx bx-copy-alt",
      title: "New Orders",
      value: data?.orders?.new !== undefined ? data.orders.new.toString() : "0",
      color: "success"
    },
    {
      icon: "bx bx-archive-in",
      title: "Redo Orders",
      value: data?.orders?.redo !== undefined ? data.orders.redo.toString() : "0",
      color: "success"
    },
    {
      icon: "bx bx-purchase-tag-alt",
      title: "Correction Orders",
      value: data?.orders?.corr !== undefined ? data.orders.corr.toString() : "0",
      color: "warning"
    },
    {
      icon: "bx bx-purchase-tag-alt",
      title: "Invoices",
      value: data?.invoice?.total !== undefined ? data.invoice.total.toString() : "0",
      color: "warning"
    },
    {
      icon: "bx bx-copy-alt",
      title: "Challans",
      value: data?.challan !== undefined ? data.challan.toString() : "0",
      color: "success"
    },
    {
      icon: "bx bx-archive-in",
      title: "Revenue",
      value: data?.invoice?.amount !== undefined ? `₹${Number(data.invoice.amount || 0).toLocaleString()}` : "₹0",
      color: "success"
    }
  ];

  return (
    <React.Fragment>
      <Card className="shadow-sm border-0">
        <CardBody>
          <Row className="mb-3 align-items-center">
            <Col>
              <h4 className="card-title mb-0">{reportType.toUpperCase()} Report</h4>
            </Col>
            <Col md="5">
              <select onChange={(e) => setReportType(e.target.value)} className="form-select form-control" name="fmytd" value={reportType}>
                <option value="ftd">FTD</option>
                <option value="mtd">MTD</option>
                <option value="ytd">YTD</option>
              </select>
            </Col>
          </Row>

          <Row className="g-3 pt-2">
            {reports.map((report, key) => (
              <Col sm="4" xs="6" key={key}>
                <div className="p-2 rounded border bg-light bg-opacity-25 h-100">
                  <div className="d-flex align-items-center mb-1">
                    <span className="font-size-12 text-muted text-truncate">{report.title}</span>
                  </div>
                  <div>
                    {loading || !data ? (
                      <div className="shimmer-box shimmer-text my-1" style={{ width: '60%', height: '20px', marginBottom: 0 }} />
                    ) : (
                      <h4 className="fw-bold mb-0 text-dark font-size-16 fade-in-content">
                        {report.value}
                      </h4>
                    )}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default FMYTDWidget
